var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":'/jobs/' + _vm.row.id + '/general-settings'}},[_vm._v(_vm._s(_vm.row.attributes.job_name))])}
var staticRenderFns = []

export { render, staticRenderFns }